export default __webpack_public_path__ + "d92057ba24abc9d0a9b918009c201334.svg";